import {httpClient} from "../../services/live4tv-client/http-client";
import {AxiosResponse} from "axios";

const config = require('config/app.config');
const LIVE4_TV_BASE_URL = config.live4tv.api_url;

export type Subscription = {
    code: string,
    currency: string,
    created_at: string,
    current_cycle: number,
    expiration_date: string,
    price: number,
    psp_subscription_reference: string,
    starting_cycle: number,
    starting_price: number,
    status: 'ACTIVE' | 'PAUSED' | 'CANCELED' | 'PENDING' | 'CREATED',
    updated_at: string
}

export type PlanFeature = {
    key: string,
    params?: {[key: string]: string | number}
}

export type Plan = {
    code: string,
    externalReference: string,
    currency: string,
    price: number,
    startingPrice: number,
    startingCycles: number,
    billingCycle: string,
}

export type PlanProduct = {
    code: string,
    externalReference: string,
    specifications: any,
    features: PlanFeature[],
    plans: Plan[]
}

export type PlanProductsResponse = {
    planProducts: PlanProduct[],
    hasPreviousSubscriptions: boolean
}

const live4tvPlanService = {
    async getActivePlan(token: string): Promise<AxiosResponse<Array<Subscription>>> {
        const url = `/api/v1/subscription/active`;

        return await httpClient.get<Array<Subscription>>(
            url,
            {
                baseURL: LIVE4_TV_BASE_URL,
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        );
    },

    async getPlanProducts(token: string, currency?: string, billingCycle?: string): Promise<AxiosResponse<PlanProductsResponse>> {
        let url = `/api/v1/plan-products`;
        const params = new URLSearchParams();
        if (currency) {
            params.append('currency', currency);
        }
        if (billingCycle) {
            params.append('billingCycle', billingCycle);
        }
        if (params.toString()) {
            url += `?${params.toString()}`;
        }

        return await httpClient.get<PlanProductsResponse>(
            url,
            {
                baseURL: LIVE4_TV_BASE_URL,
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        );
    },

    async getPlans(token: string, currency?: string): Promise<AxiosResponse<Array<Plan>>> {
        let url = `/api/v1/plans`;
        if (currency) {
            url += `?currency=${currency}`;
        }

        return await httpClient.get<Array<Plan>>(
            url,
            {
                baseURL: LIVE4_TV_BASE_URL,
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        );
    },

    async createCheckoutSession(
        token: string,
        planCode: string,
        currency: string,
        successUrl: string,
        cancelUrl: string
    ): Promise<AxiosResponse<{checkoutUrl: string}>> {
        const url = `/api/v1/payment/create-checkout-session`;

        return await httpClient.post<{checkoutUrl: string}>(
            url,
            {
                planCode,
                currency,
                successUrl,
                cancelUrl
            },
            {
                baseURL: LIVE4_TV_BASE_URL,
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }
        );
    },
}

export default live4tvPlanService;
